import { ModalInput } from './types'

//Function to create and dispatch a new custom event named 'modal' to the document.
const updateModal = (data: ModalInput) => {
  if (window?.modal !== 'true') {
    console.error(
      'You need to have the Modal Component rendered in the DOM before running this function!'
    )
  }
  const customEventData = new CustomEvent('modal', {
    /**
     * Object.assign method is used to create a new object with the data being passed.
     * If no data is passed, we add a default object
     */
    detail: Object.assign(
      {},
      //This is the default object
      {
        title: '',
        modalState: 'open',
        removeFooter: false,
        content: null,
        contentFooter: null,
        footerActions: [],
      },
      data
    ),
  })
  document.dispatchEvent(customEventData)
}

export default updateModal
